import { Injectable, Output, EventEmitter  } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpService } from './../services/http.service';
import { Globals } from '../models/globals.model';

@Injectable({
  providedIn: 'root'
})
export class PipelineService {

  apiUri: string;
  graphUri: string;

  ContinuationToken = null;
  useCaseId;
  pipelineApi = "ADF/GetPipelines";
  monitorPipelineApi = "ADF/GetPipelineRuns";
  
  @Output() linkedServiceProperties: EventEmitter<any> = new EventEmitter();
  @Output() datasetProperties: EventEmitter<any> = new EventEmitter();
   
  
  constructor(private readonly httpService: HttpService, private readonly globals: Globals, private readonly http: HttpClient) {
    this.apiUri = this.globals.config.foundationPlatformApi_client_resourceUri;
    this.graphUri = this.globals.config.graphApi_client_resourceUri;
  }

  fetchPipelines() {
    return this.http.get(this.apiUri + this.pipelineApi);
  }

  fetchPipelineList(pipelineData) {
    return this.http.post<any>(this.apiUri + this.monitorPipelineApi, pipelineData);
  }

  /**End Dataset */
}
